import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import FilterByProperty from 'components/FilterByProperty'

import { FiFilter, FiX, FiCheck } from 'react-icons/fi'
import { AiOutlineClear } from 'react-icons/ai'

const TrackFilter = () => {
  const [ searchParams, setSearchParams ] = useSearchParams()
  const [ isOpen, setIsOpen ] = useState( false )
  const _with = useState( [] )
  const level = useState( [] )

  const toggle = () => {
    setIsOpen( ! isOpen )
  }

  const reset = ( paramName, [ v, update ] ) => {
    const w = JSON.parse( searchParams.get( paramName ) )

    if ( w ) {
      update( wi => {
        const aux = [ ...wi ]
        return aux
          .map( i => {
            i.selected = false

            const inSearchParams = w.indexOf( i.name ) !== -1

            if ( inSearchParams )
              i.selected = true

            return i
          } )
      } )
    } else {
      update( wi => {
        return wi
          .map( i => ( { ...i, selected: false } ) )
      } )
    }
  }

  const close = () => {
    setIsOpen( false )

    reset( 'with', _with )
    reset( 'level', level )
  }

  const getValues = ( [ value, update ] ) => {
    return value
      .filter( i => i.selected )
      .map( i => i.name )
  }

  const applyFilters = () => {
    const w = getValues( _with )
    const l = getValues( level )

    setSearchParams( searchParams => {
      if ( w.length > 0 )
        searchParams.set( 'with', JSON.stringify( w ) )
      else
        searchParams.delete( 'with' )

      if ( l.length > 0 )
        searchParams.set( 'level', JSON.stringify( l ) )
      else
        searchParams.delete( 'level' )

      searchParams.set( '__offset', 0 )

      return searchParams
    } )

    toggle()
  }

  const clear  = ( [ v, update ] ) => {
    update( items => {
      const aux = [ ...items ]

      return aux
        .map( i => ( { ...i, selected: false } ) )
    } )
  }

  const clearFilters = () => {
    clear( _with )
    clear( level )

    setSearchParams( searchParams => {
      searchParams.delete( 'with' )
      searchParams.delete( 'level' )

      return searchParams
    } )

    setIsOpen( false )
  }

  if ( ! isOpen )
    return <button
      onClick={ toggle }
    >
      <FiFilter />
    </button>

  return <div className="scroll modal full hs ">
    <div className="bar">
      <button
      >
        <FiFilter />
      </button>

      <h1>filter</h1>

      <button
        onClick={ applyFilters }
      >
        <FiCheck />
      </button>

      <button
        onClick={ clearFilters }
      >
        <AiOutlineClear />
      </button>

      <button
        onClick={ close }
      >
        <FiX />
      </button>
    </div>

    <div className="scroll one hs">
      <FilterByProperty
        fieldName="with"
        state={ _with }
      />

      <FilterByProperty
        fieldName="level"
        state={ level }
      />
    </div>

  </div>
}

export default TrackFilter
